import { ColDef } from 'ag-grid-community';
import { t } from 'i18next';
import { upperCase } from 'lodash';

import { InputCell, UomSelectCell } from 'core/elements';
import { formatQuantity } from 'core/utils';
import { PartNumberHelper } from 'parts/helpers';

export const columnDef = (): ColDef[] => [
  {
    colId: 'number',
    headerName: t('headerPartNumber'),
    valueFormatter: ({ data }) => PartNumberHelper.toLabel(data.number),
    filter: 'agTextColumnFilter',
  },
  {
    colId: 'description',
    headerName: t('headerDescription'),
    field: 'description',
    sortable: false,
    filter: 'agTextColumnFilter',
  },
  {
    colId: 'quantity',
    headerName: t('headerQuantity'),
    sortable: false,
    field: 'quantity',
    cellRenderer: InputCell,
  },
  {
    colId: 'uom',
    headerName: t('headerUom'),
    sortable: false,
    field: 'uom',
    cellRenderer: UomSelectCell,
  },
  {
    colId: 'inventoryQuantity',
    headerName: t('headerInventory'),
    field: 'inventoryQuantity',
    valueGetter: ({ data }) => formatQuantity(data.inventoryQuantity),
  },
  {
    colId: 'inventoryUom',
    headerName: t('headerInventoryUom'),
    field: 'inventoryUom',
    filter: 'agTextColumnFilter',
    valueGetter: ({ data }) => upperCase(data?.inventoryUom),
  },
];
